import { uploadAndLinkStudentAvatar } from '@/api/resources/file.api';
import { upsertActionToast } from './useToast';
import type { IOnboardingStudent } from '@/interfaces';
import { runBulk } from 'common/utils/function.utils';
import { useI18n } from 'vue-i18n';

export function useStudentAvatarUploads() {
  const { t } = useI18n();

  /** Callers refresh student queries once after saving the students and settling all photo uploads. */
  async function uploadStudentAvatarPictures(students: IOnboardingStudent[]): Promise<void> {
    let failedCount = 0;
    const pending = students.filter((student) => student.id != null && student.avatarPictureFile);
    await runBulk(
      pending,
      async (student) => {
        if (student.id == null || !student.avatarPictureFile) return;
        try {
          const saved = await uploadAndLinkStudentAvatar(student.id, student.avatarPictureFile);
          student.avatarPictureId = saved.avatarPictureId;
          student.avatarUploadFailed = false;
        } catch {
          student.avatarUploadFailed = true;
          failedCount++;
        } finally {
          student.avatarPictureFile = null;
        }
      },
      { concurrency: 3 },
    );
    if (failedCount) {
      upsertActionToast(`student-avatar-errors:${students.map((student) => student.id).join(',')}`, {
        message: `${t('students.savedBeforeAvatarUploadFailure', { count: students.length })} ${t('students.avatarUploadFailed', { count: failedCount })}`,
        type: 'error',
        behavior: {
          autoClose: false,
          closeButton: false,
          closeOnClick: false,
          hideProgressBar: true,
          bodyClassName: 'toast-body--rich',
        },
      });
    }
  }

  return { uploadStudentAvatarPictures };
}
